<div class="container">
  <img src="../../../assets/Images/mainImage.png">
  <div class="text" (click)="start()"><h1>Explore God's Word!</h1></div>
</div>